import { render, staticRenderFns } from "./aboutUs.vue?vue&type=template&id=09058895&scoped=true"
import script from "./aboutUs.vue?vue&type=script&lang=js"
export * from "./aboutUs.vue?vue&type=script&lang=js"
import style0 from "./../style.scss?vue&type=style&index=0&id=09058895&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09058895",
  null
  
)

export default component.exports